import { GAME_SPORT } from '@shared/constants/game';
import * as soccer from './soccer';
import * as futsal from './futsal';
import * as handball from './handball';
import * as ice_hockey from './ice_hockey';
import * as tennis from './tennis';

const sportProviderMap = {
	[GAME_SPORT.SOCCER]:        soccer,
	[GAME_SPORT.FUTSAL]:        futsal,
	[GAME_SPORT.HANDBALL]:      handball,
	[GAME_SPORT.ICE_HOCKEY]:    ice_hockey,
	[GAME_SPORT.TENNIS]:        tennis,
	[GAME_SPORT.FLOORBALL]:     ice_hockey,
	[GAME_SPORT.STREET_HOCKEY]: ice_hockey,
};

export { soccer, futsal, handball, tennis, sportProviderMap, ice_hockey };
